<h2 mat-dialog-title>Additional info may be required</h2>
<div mat-dialog-content>
  <div>
    Additional actions will be required to successfully setup your phone. For example, you’ll need
    to reboot/restart your phone during the process.
  </div>
  <br />
  <div>
    To find instructions for your phone model,
    <a href="https://support.onsip.com" target="_blank">visit OnSIP’s knowledge base.</a>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close color="primary">Cancel</button>
  <button mat-flat-button color="primary" mat-dialog-close="continue">Continue to setup</button>
</div>
